import { SVGProps } from "react"

export const OutlookIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg height={800} width={800} version="1.1" viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M22,8v8a.94.94,0,0,1-1,1H14v4L2,19.2V4.8L14,3V7h7a.94.94,0,0,1,1,1m-1,.1-4,2.3L14,8.7v1.6L17,12l4-2.3V8.1m-13.08,0c-2.1-.07-3.13,1.78-3.13,4s1.07,4,3.13,4c1.87,0,3.08-1.69,3.08-3.89s-.87-4-3.08-4.08M7.61,9.7c.84,0,1.59.74,1.59,2.25s-.75,2.36-1.59,2.36S6.1,13.2,6.1,12,6.78,9.7,7.61,9.7Z" />
    </svg>
  )
}
